import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import DistributionChart from "../../../components/DistributionChart.tsx";
import KpiTile from "../../../components/KpiTile.tsx";
import SectionHeading from "../../../components/SectionHeading.tsx";
import type { CrmStatusResult } from "../../../components/prospects/collection/useCrmStatus.ts";

/**
 * List-level view of how far the exported contacts have got.
 *
 * "Enrolled" and the stage breakdown measure different things: enrolment is
 * outreach in flight, the stages are the actual pipeline, and a contact can be
 * in either without the other.
 */
export default function CrmFunnelSummary({ crm }: { crm: CrmStatusResult }) {
  if (!crm.available || !crm.summary) return null;
  const s = crm.summary;
  if (s.exported_contacts === 0) return null;

  const tiles = [
    { label: "In CRM", value: s.exported_contacts },
    { label: "In sequence", value: s.enrolled_contacts },
    { label: "Replied", value: s.replied_contacts },
    { label: "On a deal", value: s.contacts_with_deal },
  ];

  return (
    <Box sx={{ mb: 2 }}>
      <SectionHeading title="CRM progress" />
      <Grid container spacing={2} sx={{ mb: s.by_stage.length > 0 ? 2 : 0 }}>
        {tiles.map((t) => (
          <Grid key={t.label} size={{ xs: 6, md: 3 }}>
            <KpiTile dense label={t.label} value={t.value} />
          </Grid>
        ))}
      </Grid>
      {s.by_stage.length > 0 && (
        <DistributionChart
          title="Contacts by deal stage"
          data={s.by_stage.map((row) => ({ label: row.label, count: row.count }))}
        />
      )}
    </Box>
  );
}
